import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.32_db0@0.3.2_eslint@9.29.0_jiti@2.4_3e3f463021fd64430fb1090fdfb4ba99/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}